// Sidebar "NEW" badge configuration. Bump the launch timestamp when shipping
// a new section — the pill auto-hides after its launch window.
export const NEW_BADGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const SIDEBAR_LAUNCH_DATES = {
  explore: new Date('2026-04-22').getTime(),
  bookmarks: new Date('2026-04-22').getTime(),
  tools: new Date('2026-04-28').getTime(),
  prompts: new Date('2026-06-10').getTime(),
  ideas: new Date('2026-09-21').getTime(),
  // workflows: new Date('2026-05-04').getTime(),
};

const BADGE_TTL_OVERRIDES = { ideas: 14 * 24 * 60 * 60 * 1000 };

export function isSidebarItemNew(key) {
  const launchedAt = SIDEBAR_LAUNCH_DATES[key];
  const age = Date.now() - launchedAt;
  return !!launchedAt && age >= 0 && age < (BADGE_TTL_OVERRIDES[key] ?? NEW_BADGE_TTL_MS);
}
